import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { saveAs } from 'file-saver';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { Subscription } from 'rxjs';
import { RequestData } from 'src/app/modules/stp-registration/models/stp_onlinePayment.model';
import { applicationPermissions } from 'src/app/shared/application-constants/application-permissions';
import { ServerResponse } from 'src/app/shared/models/dto/server-response.dto';
import { CommonStorageService } from 'src/app/shared/services/common-storage.service';
import { ExcelDownloadService } from 'src/app/shared/services/excel-download.service';
import { TamMainSearchResultDto } from '../../models/dto/tam_main_search_result_dto.model';
import { TamIndustrialSector } from '../../models/tam-Industrial-sector.model';
import { TamMainSearch } from '../../models/tam-main-search.model';
import { TamOccupation } from '../../models/tam-occupation.model';
import { TamType } from '../../models/tam-type.model';
import { TrainingAndAssessmentMaterialsStorageService } from '../../services/training-and-assessment-materials-storage.service';
import { TrainingAndAssessmentMaterialsService } from '../../services/training-and-assessment-materials.service';
import {CblmService} from "../../services/cblm.service";
import JSZip from "jszip";

@Component({
  selector: 'app-tam-list',
  templateUrl: './tam-list.component.html',
  styleUrls: ['./tam-list.component.scss'],
})
export class TamListComponent implements OnInit {
  applicationPermissions = applicationPermissions;
  tamMainSearchResultDto: TamMainSearchResultDto[] = [];
  onTamMainSubscription$: Subscription;
  file: any = File;

  tamTypeDecodedId: any;
  tamTypeId: number;

  requestData: RequestData = new RequestData();
  userInfo: any;
  reportData: any;
  searchForm: FormGroup;

  tamOccupations: TamOccupation[] = [];
  onTamOccupationSubscription$: Subscription;
  selectedOccupation?: TamOccupation;

  tamTypes: TamType[] = [];
  onTamTypeSubscription$: Subscription;
  selectedTamType?: TamType;
  selectedValue: number;

  tamIndustrialSectors: TamIndustrialSector[] = [];
  onTamIndustrialSectorSubscription$: Subscription;

  tamMainSearch: TamMainSearch;

  totalData: number = 0;
  pageSize: number = 10;
  currentPage: number = 1;
  sortingKey: string;
  sortingValue: string;

  hiddingHeaderFooter: boolean = true;

  // for pagination
  total: number;
  size: number = 10;
  page: number = 1;

  archiveList: { id: boolean; name: string }[] = [
    { id: true, name: 'Yes' },
    { id: false, name: 'No' },
  ];
  cblmAttachmentList: any;

  statusOptions = [
    { label: 'Drafted', value: 0 },
    { label: 'Submitted', value: 2 }
  ];

  constructor(
    private trainingAndAssessmentMaterialsService: TrainingAndAssessmentMaterialsService,
    private trainingAndAssessmentMaterialsStorageService: TrainingAndAssessmentMaterialsStorageService,
    private notification: NzNotificationService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    private excelExport: ExcelDownloadService,
    private commonStorageService: CommonStorageService,
    private datepipe: DatePipe,
    private cd: ChangeDetectorRef,
    private cblmService: CblmService,
  ) {
    this.userId();
    (window.location.href.includes("home")) ? this.hiddingHeaderFooter = true : (!(this.userInfo?.roles == null)) ? this.hiddingHeaderFooter = false : this.hiddingHeaderFooter = false ;
  }

  ngOnInit(): void {
    this.createSearchForm();
    this.getIndustrialSectorList();
    this.getTamTypeList();
    this.getOccupationList();
    this.submitSearchForm();

    this.activatedRoute.queryParams.subscribe((params) => {
      const base64EncodedValue = params['tamTypeId'];
      if (base64EncodedValue) {
        try {
          this.tamTypeDecodedId = atob(base64EncodedValue);
          this.searchForm.get('tamTypeId')?.setValue(Number(this.tamTypeDecodedId));
          this.searchForm.get('tamTypeId')?.updateValueAndValidity();
          this.submitSearchForm();
        } catch (e) {
          console.error('Invalid Base64 encoded value:', e);
        }
      } else {
        console.warn('tamTypeId parameter not found in query params');
      }
    });
  }

  onEdit(id: number | undefined): void {
    // this.trainingAndAssessmentMaterialsService.setEditingTamMainSearchResultId(id);
    this.router.navigate(['/home/training-and-assessment-materials/tam-update'], {
      queryParams: { tamMainId: id},
      relativeTo: this.activatedRoute,
    });
  }

  // onDownload(data: any): void {
  //   this.commonStorageService.downloadFile(data.docFilePath).subscribe({
  //     next: (result: any) => {
  //       var fileName = data.tamApplicationId;
  //       const contentDisposition = result.headers.get('Content-Disposition');
  //       if (contentDisposition) {
  //         const fileNameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
  //         const matches = fileNameRegex.exec(contentDisposition);
  //         if (matches != null && matches[1]) {
  //           var totalFileName = matches[1].replace(/['"]/g, '');
  //           var fullFile = totalFileName.split('.');
  //           var exten = fullFile[1];
  //           fileName = fileName + '.' + exten;
  //         }
  //       }
  //       saveAs(result.body, fileName);
  //     },
  //     error: (error) => this.notification.error('Failed!', 'No file found!'),
  //   });
  // }


  onDownload(data: any): void {
    const zip = new JSZip();
    const BASE_URL = "http://localhost:8501";


    const mainFilePromise = data.docFilePath
      ? this.commonStorageService.downloadFile(data.docFilePath)
        .toPromise()
        .catch(err => {
          console.warn('No main TAM file—skipping ZIP entry:', err);
          return null;
        })
      : Promise.resolve(null);

    const attachmentRequestBody = {
      tam_occupation_id: {type: 'occupation', value: data.tamOccupationId || ''},
      sector: {type: 'sector-specific', value: data.sector || ''},
      generic: {type: 'generic', value: data.generic || ''}
    };
    const attachmentsPromise = this.cblmService
      .getCBLMAttachments(attachmentRequestBody)
      .toPromise()
      .catch(err => {
        console.error('Failed to fetch attachment list:', err);
        return [];
      });

    Promise.all([mainFilePromise, attachmentsPromise])
      .then(async ([mainFileRes, attachments]) => {

        // — Add the main file if we actually got one
        if (mainFileRes && mainFileRes.body) {
          const blob = mainFileRes.body as Blob;
          let fileName = data.tamApplicationId + '.pdf';

          const cd = mainFileRes.headers.get('Content-Disposition');
          if (cd) {
            const m = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(cd);
            if (m?.[1]) {
              fileName = m[1].replace(/['"]/g, '');
            }
          }

          zip.file(fileName, blob);
        }

        // — Always loop though attachments (empty array if the call failed)
        for (let i = 0; i < attachments.length; i++) {
          try {
            const relativeUrl = attachments[i];
            const fullUrl = `${BASE_URL}/api/file-download?fileUrl=${relativeUrl}`;
            const res = await fetch(fullUrl);
            if (!res.ok) throw new Error(`HTTP ${res.status}`);

            const blob = await res.blob();
            const fn = relativeUrl.split('/').pop() || `attachment_${i + 1}`;
            zip.file(fn, blob);
          } catch (err) {
            console.warn(`Skipping attachment #${i + 1}:`, err);
          }
        }

        // — Finally, build and save the ZIP
        return zip.generateAsync({type: 'blob'});
      })
      .then(zipBlob => saveAs(zipBlob, `${data.tamApplicationId}_documents.zip`))
      .catch(err => {
        console.error('Download/ZIP failed:', err);
        this.notification.error('Download Failed', 'Could not bundle the files');
      });
  }




  userId() {
    this.userInfo = JSON.parse(localStorage.getItem('currentUserInfo') || '{}');
    this.requestData.id = this.userInfo.id;
  }

  selectedCourseAccreditationDocument(tamMainId: number | undefined): void {
    const url = (!(this.userInfo?.roles == null)) ?'/home/training-and-assessment-materials/tam-view/':
    '/tam-view/';
    this.router.navigate([url], {
      queryParams: { tamMainId: tamMainId},
      relativeTo: this.activatedRoute,
    });
  }

  createSearchForm() {
    this.searchForm = this.fb.group({
      tamTypeId: [null],
      tamOccupationId: [null],
      isPublished: [null],
      isArchived: [null],
      tamApplicationId: [null],
      industrialSectorId: [null],
      status: [null]
    });
  }

  resetForm(): void {
    this.searchForm.reset();
  }

  getTamTypeList() {
   this.tamTypes = this.trainingAndAssessmentMaterialsService.getTamTypes();

    if (this.tamTypes.length === 0) {
      this.trainingAndAssessmentMaterialsStorageService
        .readTamTypes()
        .subscribe();
    }
    this.onTamTypeSubscription$ =
      this.trainingAndAssessmentMaterialsService.onRefreshTamTypeList.subscribe(
        (res) => {
          this.tamTypes = res;
        }
      );
  }

  getOccupationList() {
    this.tamOccupations =
      this.trainingAndAssessmentMaterialsService.getTamOccupations();

    if (this.tamOccupations.length === 0) {
      this.trainingAndAssessmentMaterialsStorageService
        .readTamOccupations()
        .subscribe();
    }
    this.onTamOccupationSubscription$ =
      this.trainingAndAssessmentMaterialsService.onRefreshTamOccupationList.subscribe(
        (res) => {
          this.tamOccupations = res;
        }
      );
  }

  getIndustrialSectorList() {
    this.tamIndustrialSectors =
      this.trainingAndAssessmentMaterialsService.getTamIndustrialSectors();

    if (this.tamIndustrialSectors.length === 0) {
      this.trainingAndAssessmentMaterialsStorageService
        .readTamIndustrialSectors()
        .subscribe();
    }
    this.onTamIndustrialSectorSubscription$ =
      this.trainingAndAssessmentMaterialsService.onRefreshTamIndustrialSectorList.subscribe(
        (res) => {
          this.tamIndustrialSectors = res;
        }
      );
  }

  getTamMainSearchResult(tamMainSearch: TamMainSearch) {
    // if(this.tamTypeDecodedId){
    //   tamMainSearch.tamTypeId = this.tamTypeDecodedId;
    // }
    this.trainingAndAssessmentMaterialsStorageService
      .searchTamMain(tamMainSearch)
      .subscribe(
        (res: ServerResponse) => {
          if (res.success) {
            this.tamMainSearchResultDto = res.data;
            this.tamMainSearchResultDto.forEach(tamMain => {
              if (Array.isArray(tamMain.approvalDate)) {
                tamMain.approvalDate = this.convertDateArray(tamMain.approvalDate);
              }
              // Add similar conversion for any other date fields if needed.
            });

            this.total = res.count;
            if (
              this.userInfo?.roles &&
              this.userInfo?.roles[0].name === 'User'
            ) {
              this.tamMainSearchResultDto = this.tamMainSearchResultDto.filter(
                (tamMain) => tamMain.isPublished === true
              );
            }
          } else {
            this.tamMainSearchResultDto = [];
            this.total = 0;
          }
        },
        (error) => {
          this.notification.warning(
          'Warning !',
          'No data available !'
        );
          this.tamMainSearchResultDto = [];
          this.total = 0;
        }
      );
  }

  onPageIndexChange(pageIndex: number) {
    this.currentPage = pageIndex;
    this.tamMainSearch.pageNumber = this.currentPage - 1;

    this.getTamMainSearchResult(this.tamMainSearch);
  }

  onQueryParamsChange(params: NzTableQueryParams): void {
    this.currentPage= params.pageIndex;
    this.size = params.pageSize;
    params.sort.forEach((element) => {
      if (element.value != null) {
        this.sortingKey = element.key;
        this.sortingValue = element.value;
      }
    });
    this.submitSearchForm();
  }

  submitSearchForm() {
    this.tamMainSearch = this.searchForm.value;
    this.tamMainSearch.pageSize = this.pageSize;
    this.tamMainSearch.pageNumber = this.currentPage - 1;
    this.tamMainSearch.sortingKey = this.sortingKey;
    this.tamMainSearch.sortingValue = this.sortingValue;
    this.getTamMainSearchResult(this.tamMainSearch);
  }

  OnDestroy(): void {
    this.onTamMainSubscription$.unsubscribe();
  }


  onDownloadReport() {
    this.trainingAndAssessmentMaterialsStorageService
     .onDownloadTamMainReport(this.tamMainSearch)
      .subscribe(
        (res) => {
            this.reportData = res.data;
            let reportTitle = 'TAM List';
            if (this.reportData === null || this.reportData?.length === 0) {
              // this.toastr.error('No data available to download');
              this.notification.warning(
                'Warning!',
                'No data available to download'
              );
            } else {
              const dataList = this.getFormatDataForExcel(this.reportData);
              this.excelExport.exportExcel(dataList, reportTitle);
            }
          },
          (error) => {
            this.notification.error('Error!', 'Excel Sheet Data fetch Failed');
          }
      );
  }

  getFormatDataForExcel(dataReport: any) {
    let i = 1;
    const dataList = [];
    for (const data of dataReport) {
      const reportMap = new Map();
      reportMap.set('#SL', i);
      reportMap.set('ID', data.applicationId);
      //reportMap.set('Date Created', data.createdDate);
      reportMap.set('Date Created', this.transformDate(data.createdDate));
      reportMap.set('Type', data.tamTypeName);
      reportMap.set('Industrial Sector', data.tamIndustrialSectorName);
      reportMap.set('Occupation', data.tamOccupationName);
      reportMap.set('DocFilePath', data.docFilePath);
      reportMap.set('Level', data.tamLevelId);
      reportMap.set('Duration', data.duration);
      reportMap.set('Language', data.tamLanguageName);
      reportMap.set('Version', data.version);
      reportMap.set('Approval Date', this.transformDate(data.approvalDate));
      reportMap.set('Source', data.docSource);
      reportMap.set('Received Date', this.transformDate(data.receivedDate));
      reportMap.set('Access Type',data.isPublished ? 'Public' : 'Limited');
      if(data?.tamCsOnDownloadDtoList){
        for(let i =0;i<data.tamCsOnDownloadDtoList.length;i++){
          reportMap.set('Title - '+(i+1), data.tamCsOnDownloadDtoList[i]?.title ?? null);
          reportMap.set('Uoc Code - '+(i+1), data.tamCsOnDownloadDtoList[i]?.unitCode ?? null);
          reportMap.set('Duration - '+(i+1), data.tamCsOnDownloadDtoList[i]?.duration ?? null);
        }
      }else{
        reportMap.set('Title - '+(i+1), null);
        reportMap.set('Uoc Code - '+(i+1), null);
        reportMap.set('Duration - '+(i+1), null);
      }

      const jsonObject: any = {};
      reportMap.forEach((value, key) => {
        jsonObject[key] = value;
      });

      dataList.push(jsonObject);
      i++;
    }

    return dataList;
  }

  // transformDate(value: any): string | null {
  //   try {
  //     if (!value) return null;

  //     if (value instanceof Date) {
  //       return this.datepipe.transform(value, 'MM-dd-yyyy');
  //     }

  //     if (typeof value === 'string' && value.includes(',')) {
  //       const parts = value.split(',').map(Number);
  //       const dateObj = new Date(parts[0], parts[1] - 1, parts[2], parts[3] || 0, parts[4] || 0);
  //       return this.datepipe.transform(dateObj, 'MM-dd-yyyy');
  //     }

  //     const date = new Date(value);
  //     if (isNaN(date.getTime())) return null;
  //     return this.datepipe.transform(date, 'MM-dd-yyyy');
  //   } catch (err) {
  //     return null;
  //   }
  // }

transformDate(value: any): string | null {
  try {
    if (!value) return null;

    if (value instanceof Date) {
      return this.datepipe.transform(value, 'yyyy-MM-dd');
    }

    if (typeof value === 'string' && value.includes(',')) {
      const parts = value.split(',').map(Number);
      const dateObj = new Date(parts[0], parts[1] - 1, parts[2], parts[3] || 0, parts[4] || 0);
      return this.datepipe.transform(dateObj, 'yyyy-MM-dd HH:mm');
    }

    const date = new Date(value);
    if (isNaN(date.getTime())) return null;
    return this.datepipe.transform(date, 'yyyy-MM-dd');
  } catch (err) {
    return null;
  }
}



  // getCblmAttachments(row: TamMainSearchResultDto) {
  //   const requestBody = {
  //     tam_occupation_id: {
  //       type: 'occupation',
  //       value: row.tamOccupationId || ''
  //     },
  //     sector: {
  //       type: 'sector-specific',
  //       value: row.sector || ''
  //     },
  //     generic: {
  //       type: 'generic',
  //       value: row.generic || ''
  //     }
  //   };
  //   console.log(JSON.stringify(requestBody));
  //
  //   this.cblmService.getCBLMAttachments(requestBody).subscribe(
  //     (res) => {
  //       this.cblmAttachmentList = res;
  //       console.log('res -------------------------->',res)
  //     },
  //     (error) => {
  //       console.error('Error fetching attachments', error);
  //     }
  //   );
  // }


  // onPrintAttachments(row: TamMainSearchResultDto): void {
  //   const requestBody = {
  //     occupation: {
  //       type: 'occupation',
  //       value: row.tamOccupationId || ''
  //     },
  //     sector: {
  //       type: 'sector-specific',
  //       value: row.sector || ''
  //     },
  //     generic: {
  //       type: 'generic',
  //       value: row.generic || ''
  //     }
  //   };
  //   console.log(JSON.stringify(requestBody));
  // }

  // In your component class
  private convertDateArray(dateArray: number[]): Date | null {
    if (Array.isArray(dateArray) && dateArray.length >= 3) {
      // Destructure with default values in case parts are missing (month is 0-indexed in JS)
      const [year, month, day, hour = 0, minute = 0, second = 0] = dateArray;
      return new Date(year, month - 1, day, hour, minute, second);
    }
    return null;
  }




}
